module.exports = __webpack_public_path__ + "static/media/promotionNews1.62eb0abb.png";